export enum PaymentTypes {
  PAY_ON_LOCATION = 'payOnLocation',
  PAY_NOW = 'payNow',
  ONE_TIME = 'oneTimePayment',
}
